// removed by extract-text-webpack-plugin
module.exports = {"unsubscribeBtn":"_1gKwHIqGTvsTMPY19fKliO"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Unsubscribe/style.scss
// module id = 985
// module chunks = 0